<template>
  <div class="buy">
    <div class="box">
      <img src="~@/assets/img/img_banner_purchase.svg" class="banner-purchase">
      <div class="container">
        <div class="container-title">请尽量填写较全的购买信息,*为必填</div>
        <el-form :model="form" :rules="rules" ref="form" label-width="110px" size="mini">
          <div class="container-main">
            <el-form-item label="用户名" prop="user_name">
              <el-input v-model="form.user_name" placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="form.phone" maxlength="11" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="短信验证码" prop="sms">
              <div class="input-button">
                <el-input v-model="form.sms" placeholder="请输入验证码"></el-input>
                <el-button type="primary" class="sms-button" :disabled="state.smsSendBtn" @click.stop.prevent="getCaptcha" v-text="
                    (!state.smsSendBtn && '获取验证码') ||
                      state.time + ' 秒后获取'
                  ">
                </el-button>
              </div>
            </el-form-item>
            <el-form-item label="公司名称" prop="company_name">
              <el-input v-model="form.company_name" placeholder="请输入公司名称"></el-input>
            </el-form-item>
            <el-form-item label="营业执照" prop="fileList">
              <el-upload
                action=""
                :with-credentials="true"
                accept="image/png,image/jpeg,image/jpg"
                :limit="3"
                list-type="picture-card"
                :http-request="handleHttpRequest"
                :file-list="form.fileList"
                :on-change="fileChange"
                :on-remove="handleRemove"
                :on-exceed="handleExceed"
                :before-upload="handleBeforeUpload"
                :on-preview="handlePictureCardPreview"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="支付方式" prop="payment_method">
              <el-select v-model="form.payment_method" placeholder="请选择支付方式">
                <el-option label="微信" value="1"></el-option>
<!--                <el-option label="支付宝" value="2"></el-option>-->
              </el-select>
            </el-form-item>
            <el-form-item label="开通模式" prop="purchase_type" v-if="priceInfo">
              <el-select v-model="form.purchase_type" placeholder="请选择开通模式"
                         @change="onPurchaseType">
                <el-option :label="`按季度购买，${priceInfo.season_now_price}元/季`" value="2"></el-option>
                <el-option :label="`按年购买，${priceInfo.year_now_price}元/年`" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="优惠码" prop="invitation_code">
              <div class="input-button invitation-code">
                <el-input v-model="form.invitation_code" placeholder="请输入优惠码">
                  <i slot="suffix" v-show="discount.isUsed===3" class="el-input__icon el-icon-close"
                     style="color:#F56C6C;"></i>
                  <i slot="suffix" v-show="discount.isUsed===2" class="el-input__icon el-icon-check"
                     style="color:#67C23A;"></i>
                </el-input>
                <el-button type="primary" class="sms-button" @click="onCheckInvitationCode">
                  使用
                </el-button>
              </div>
            </el-form-item>
            <el-form-item label="购买时长">
              <span v-show="buyTime && buyTime !== ''">{{buyTime}}个月</span>
            </el-form-item>
            <el-form-item label="实际支付">
              <span class="total-money" v-show="totalMoney&&totalMoney!==''">¥{{totalMoney}}</span>
            </el-form-item>
          </div>
          <div class="container-footer">
            <el-checkbox v-model="form.checked">
              我已经阅读并接受
              <a href="javascript:;" class="argument" @click="dialog.agreement.visible = true"
                 v-if="agreementInfo">
                《{{agreementInfo.title}}》
              </a>
            </el-checkbox>
            <div style="text-align:center;">
              <el-button type="danger" round class="save-button" :disabled="!form.checked"
                         @click="onSubmit('form')">
                确认支付
              </el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="wavy-line"></div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <!--  协议-->
    <el-dialog
      custom-class="dialog-agreement"
      title=""
      :show-close="false"
      :visible.sync="dialog.agreement.visible"
      center>
      <div class="header">
        <img src="~@/assets/img/img_agreement.svg">
      </div>
      <div class="body" v-if="agreementInfo">
        <div v-html="agreementInfo.content"></div>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button type="danger" round @click="dialog.agreement.visible = false" size="small"
               class="btn">
      我知道了
    </el-button>
  </span>
    </el-dialog>
    <!--  支付码-->
    <el-dialog
      title="微信支付"
      custom-class="dialog-payment"
      :visible.sync="dialog.payment.visible"
      center>
      <div class="body">
        <p class="body-tip">请用微信扫描二维码以完成支付</p>
        <img class="qrcode" v-if="payInfo" :src="this.$axios.defaults.baseURL+'pay/pay/png?url='+payInfo.result.code_url" alt="支付二维码">
      </div>
      <p class="tip">支付后未跳转，请点击</p>
      <span slot="footer" class="dialog-footer">
    <el-button type="danger" round @click="payFinished(true)" size="small" class="btn">
      支付完成
    </el-button>
  </span>
    </el-dialog>
<!--    支付完成-->
    <el-dialog
      title="微信支付"
      custom-class="dialog-payment-finished"
      :visible.sync="dialog.paymentFinished.visible"
      center>
      <div class="body">
        <div class="main">
          <div class="img-container">
            <img src="~@/assets/img/img_success.svg" alt="成功">
          </div>
          <div class="img-container qrcode">
            <img src="~@/assets/img/img_applet.jpg" alt="小程序码">
          </div>
        </div>
        <div class="mobile-main">
          <div class="img-container qrcode">
            <img src="~@/assets/img/img_applet.jpg" alt="小程序码">
          </div>
          <div class="img-container">
            <img src="~@/assets/img/img_success.svg" alt="成功">
          </div>
        </div>
        <p class="body-tip">支付成功，请扫小程序码进行登录....</p>
      </div>
      <span slot="footer" class="dialog-footer">
<!--        <p class="footer-tip">小程序码未加载，<a href="javascript:;">刷新</a></p>-->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { multipartUpload } from '@/utils/oss';
import {
  toPay, getAgreement, checkInvitationCode, checkOrder, getPng,
} from '@/api/buy';
import { getPrice } from '@/api';

import { sendSms } from '@/api/common';

export default {
  name: 'buy',
  created() {
  },
  data: () => ({
    agreementInfo: null,
    priceInfo: null,
    form: {
      user_name: '',
      phone: '',
      sms: '',
      company_name: '',
      payment_method: '',
      purchase_type: '',
      invitation_code: '',
      fileList: [],
      checked: false,
    },
    rules: {
      user_name: [
        {
          required: true,
          message: '请输入用户名',
          trigger: 'blur',
        },
      ],
      phone: [
        {
          required: true,
          message: '请输入手机号',
          trigger: 'blur',
        },
        {
          pattern: /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/,
          message: '手机号格式不正确',
          trigger: 'blur',
        },
      ],
      sms: [
        {
          required: false,
          message: '请输入验证码',
          trigger: 'blur',
        },
      ],
      company_name: [
        {
          required: false,
          message: '请填写企业名称',
          trigger: 'blur',
        },
        {
          max: 50,
          message: '最多50个字',
          trigger: 'change',
        },
        {
          pattern: /^[a-z0-9\u4e00-\u9fa5\（\）\/]+$/,
          message: '仅支持汉字、字母、数字及（）/',
          trigger: 'change',
        },
      ],
      payment_method: [
        {
          required: true,
          message: '请选择支付方式',
          trigger: 'change',
        },
      ],
      purchase_type: [
        {
          required: true,
          message: '请选择开通模式',
          trigger: 'change',
        },
      ],
      fileList: [
        {
          required: false,
          message: '请上传营业执照',
          trigger: 'blur',
        },
      ],
    },
    dialogImageUrl: '',
    dialogVisible: false,
    dialog: {
      agreement: {
        visible: false,
      },
      payment: {
        visible: false,
      },
      paymentFinished: {
        visible: false,
      },
    },
    discount: {
      isUsed: 1, // 1-无状态,2-未使用,3-已使用
      info: null,
    },
    totalMoney: '',
    buyTime: '',
    state: {
      smsSendBtn: false,
      time: 60,
    },
    payInfo: null,
    payFinishedTimer: null,
  }),
  created() {
    getAgreement()
      .then((res) => {
        if (res.status === 0) {
          this.agreementInfo = res.data;
        } else {
          this.agreementInfo = null;
        }
      });
    getPrice(1).then((res) => {
      if (res.status === 0) {
        this.priceInfo = res.data;
      }
    });
  },
  methods: {
    fileChange(file, fileList) {
      this.form.fileList = fileList;
    },
    handleRemove(file, fileList) {
      this.form.fileList = fileList;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleExceed(files, fileList) {
      this.$message.warning('最多上传 3 张图片');
    },
    handleBeforeUpload(file) {
      const { type } = file;
      if (['image/png', 'image/jpeg', 'image/jpg'].indexOf(type) === -1) {
        this.$message.error('请选择正确的文件格式');
        return false;
      }
      if (file.size / 1024 / 1024 > 8) {
        this.$message.error('图片不能超过8M');
        return false;
      }
      return true;
    },
    handleHttpRequest(option) {
      console.log(option);
      multipartUpload(option.file.name, option.file, async (p) => {
        const e = {};
        e.percent = p * 100;
        option.onProgress(e);
      })
        .then((ret) => {
          if (ret.res.statusCode === 200) {
            option.onSuccess(ret);
          } else {
            option.onError('上传失败');
          }
        });
    },
    // 发送验证码
    getCaptcha(e) {
      e.preventDefault();
      const that = this;
      if (that.state.isSending) {
        return;
      }
      const formValues = this.form;

      if (/^[1][2,3,4,5,6,7,8,9][0-9]{9}$/.test(formValues.phone)) {
        that.state.isSending = true;
        const interval = window.setInterval(() => {
          that.state.smsSendBtn = true;
          if (that.state.time-- <= 0) {
            that.state.time = 60;
            that.state.smsSendBtn = false;
            that.state.isSending = false;
            window.clearInterval(interval);
          }
        }, 1000);


        that.$message({
          type: 'info',
          message: '验证码发送中..',
        });
        sendSms(formValues.phone)
          .then((res) => {
            if (res.status === 0) {
            } else {
              this.$message.error(res.msg);
              window.clearInterval(interval);
              that.state.time = 60;
              that.state.smsSendBtn = false;
              that.state.isSending = false;
            }
          })
          .catch((err) => {
            window.clearInterval(interval);
            that.state.time = 60;
            that.state.smsSendBtn = false;
            that.requestFailed(err);
            that.state.isSending = false;
          });
      } else {
        that.$message.error('手机号格式错误');
      }
    },
    requestFailed(err) {
      const errMsg = (err.data && err.data.msg) || err.msg || '请求出现错误，请稍后再试';
      this.$message.error(errMsg);
      this.state.submitBtn = false;
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const {
            user_name,
            phone, sms, company_name, fileList, payment_method, purchase_type, invitation_code,
          } = { ...this.form };
          const licenseImgList = [];
          if (fileList && fileList.length > 0) {
            for (const item of fileList) {
              if (item.response) {
                let url = item.response.res.requestUrls[0];
                if (/^(.*)\?/.test(url)) {
                  url = url.match(/^(.*)\?/)[1];
                }
                licenseImgList.push(url);
              } else {
                licenseImgList.push(item.url);
              }
            }
          }
          const parameter = {
            user_name,
            phone,
            // sms,
            company_name,
            payment_method,
            purchase_type,
            invitation_code,
            order_source: '1',
            license_img: licenseImgList.join(','),
          };

          toPay(parameter).then((res) => {
            if (res.status === 0) {
              const { data } = res;
              this.payInfo = data;
              this.dialog.payment.visible = true;
              this.payFinished();
              this.payFinishedTimer = setInterval(() => {
                this.payFinished();
              }, 5000);
            } else {
              this.payInfo = null;
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    onCheckInvitationCode() {
      const invitationCode = this.form.invitation_code;
      if (!invitationCode || invitationCode === '') {
        this.$message.error('请输入邀请码');
        return false;
      }
      checkInvitationCode(invitationCode)
        .then((res) => {
          if (res.status === 0) {
            const { data } = res;
            data.discount_money = parseFloat(data.discount_money);
            this.discount = {
              isUsed: 2,
              info: data,
            };
            if (this.totalMoney && this.totalMoney !== '') {
              const totalMoney = this.totalMoney - data.discount_money;
              this.totalMoney = totalMoney > 0 ? totalMoney : '0';
            }
            this.$message({
              type: 'success',
              message: res.msg,
            });
          } else {
            this.discount = {
              isUsed: 3,
              info: null,
            };
            this.$message.error(res.msg);
          }
        });
    },
    onPurchaseType(e) {
      let discount_money = 0;
      if (this.discount.info) {
        discount_money = this.discount.info.discount_money;
      }
      switch (e) {
        case '1':
          this.totalMoney = (128 - discount_money) > 0 ? 128 - discount_money : '0';
          this.buyTime = 12;
          break;
        case '2':
          this.totalMoney = (48 - discount_money) > 0 ? 48 - discount_money : '0';
          this.buyTime = 3;
          break;
      }
    },
    payFinished(isClick) {
      checkOrder(this.payInfo.order_id).then((res) => {
        if (res.status === 2) {
          clearInterval(this.payFinishedTimer);
          this.dialog.payment.visible = false;
          this.dialog.paymentFinished.visible = true;
        } else if (isClick) {
          clearInterval(this.payFinishedTimer);
          this.dialog.payment.visible = false;
          this.$message.error('支付失败，请重新发起支付');
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .buy {
    position: relative;
    width: 100%;
    min-height: 100%;
    background: #ffd33c;
  }
  .tip{
    color: #999;
    font-size: 12px;
    text-align: center;
  }

  .box {
    position: relative;
    margin: 0 auto;
    padding: 16px 16px 50px 16px;
    width: 100%;
    max-width: 1000px;
    height: 100%;
  }

  .banner-purchase {
    display: block;
    margin: 0 auto;
  }

  .container {
    position: relative;
    width: 100%;
    background: #fff;
    border-radius: 6px;
    z-index: 100;
  }

  .container-title {
    height: 60px;
    line-height: 60px;
    color: $tip-color;
    font-size: 14px;
    text-align: center;
    border-radius: 6px 6px 0 0;
    border-bottom: 1px solid $border-color;
  }

  .container-main {
    margin: 0 auto;
    max-width: 600px;
    width: 100%;
    padding: 16px 0 0 0;
  }

  .input-button {
    position: relative;
    padding-right: 132px;

    .sms-button {
      position: absolute;
      right: 0;
      top: 0;
      color: #fff;
      background: #f4a117;
      font-weight: 400;
      &.is-disabled{
        background-color: #fad08b;
      }
    }

    &.invitation-code {
      padding-right: 100px;
      max-width: 300px;
    }
  }

  .total-money {
    font-size: 22px;
    color: $color-primary;
    font-weight: 600;
  }

  .container-footer {
    padding: 20px;
    border-top: 1px solid $border-color;
    text-align: center;

    .argument {
      color: $color-primary;
      text-decoration: none;
    }
  }

  .wavy-line {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 236px;
    background: url('~@/assets/img/img_background.png') no-repeat;
    background-size: 100% 100%;
  }

  .save-button {
    margin-top: 20px;
    max-width: 280px;
    width: 100%;
  }

  .dialog-agreement {
    .header {
      padding: 10px 0;
      border-bottom: 1px solid $border-color;

      img {
        display: block;
        width: 100%;
        margin: 0 auto;
        max-width: 300px;
      }
    }

    .body {
      padding: 24px 34px;
      height: 400px;
      overflow: auto;
    }

    .btn {
      padding: 9px 30px;
    }

  }

  .dialog-payment{
    .btn {
      padding: 9px 30px;
    }
    .body{
      border-top: 1px solid $border-color;
      .body-tip{
        text-align:center;
        font-size: 12px;
      }
    }
    .tip{
      margin: 0;
      padding-top: 5px;
      border-top: 1px solid $border-color;
    }
    .btn {
      padding: 9px 30px;
    }
    .qrcode{
      display: block;
      margin: 0 auto;
      width: 236px;
      height: 236px;
    }
  }

  .dialog-payment-finished{
    .body-tip{
      margin-bottom: 0;
      text-align: center;
      font-weight: 600;
      color: #000;
    }
    .body{
      .main{
        margin: 0 auto;
        padding: 30px 0;
        width: 481px;
        .img-container{
          padding: 0 54px;
          display: inline-block;
          vertical-align: middle;
          &:first-of-type{
            border-right: 1px solid $border-color;
          }
          &.qrcode{
            img{
              width: 150px;
            }
          }
          img{
            width: 100px;
          }
        }
      }
      .mobile-main{
        display: none;
      }
    }
    .footer-tip{
      color: #999;
      font-size: 12px;
      a{
        text-decoration: underline;
      }
    }
  }

  @media (max-width: 768px) {
    .container-title {
      height: 35px;
      line-height: 35px;
      font-size: 13px;
    }
    .banner-purchase {
      width: 100%;
    }
    .container-main {
      padding-right: 16px;
    }
    .input-button {
      padding-right: 99px;

      &.invitation-code {
        padding-right: 62px;
      }
    }
    .dialog-agreement {
      .header {
        padding: 10px 22px;
      }

      .body {
        height: 254px;
      }
    }
    .dialog-payment-finished{
      .body{
        .main{
          display: none;
        }
        .mobile-main{
          display: block;
          .img-container{
            padding: 10px 0;
            border-top: 1px solid $border-color;
            img{
              display: block;
              margin: 0 auto;
              width: 80px;
            }
            &.qrcode{
              border-top: 0 none;
              img{
                width: 229px;
              }
            }
          }
        }
      }
    }
  }

</style>
